/** Longueur minimale d'un nouveau mot de passe. Doit rester égale à PASSWORD_MIN côté backend (auth/password-policy.ts). */
export const PASSWORD_MIN = 12;

import type { TranslationKey } from '../i18n';

type TFn = (key: TranslationKey, vars?: Record<string, string | number>) => string;

export interface PwdStrength {
  score: number; // 0..4
  label: string;
  color: string;
  hints: string[];
}

export function evaluatePassword(pwd: string, t: TFn): PwdStrength {
  const hints: string[] = [];
  if (pwd.length < PASSWORD_MIN) hints.push(t('team_reset_hintLength', { n: PASSWORD_MIN }));
  if (!/[A-Z]/.test(pwd)) hints.push(t('team_reset_hintUpper'));
  if (!/[a-z]/.test(pwd)) hints.push(t('team_reset_hintLower'));
  if (!/[0-9]/.test(pwd)) hints.push(t('team_reset_hintDigit'));
  if (!/[^A-Za-z0-9]/.test(pwd)) hints.push(t('team_reset_hintSpecial'));

  let score = 0;
  if (pwd.length >= PASSWORD_MIN) score++;
  if (pwd.length >= 16) score++;
  if (/[A-Z]/.test(pwd) && /[a-z]/.test(pwd)) score++;
  if (/[0-9]/.test(pwd) && /[^A-Za-z0-9]/.test(pwd)) score++;
  score = Math.min(4, score);

  const labels = [t('team_reset_strength0'), t('team_reset_strength1'), t('team_reset_strength2'), t('team_reset_strength3'), t('team_reset_strength4')];
  const colors = ['bg-red-500', 'bg-orange-500', 'bg-amber-500', 'bg-emerald-500', 'bg-emerald-600'];
  return { score, label: labels[score], color: colors[score], hints };
}
